export const casteList = [
  {
    name: 'General Category (GC)',
  },
  {
    name: 'Scheduled Caste (SC)',
  },
  {
    name: 'Scheduled Tribe (ST)',
  },
  {
    name: 'Other Backward Class (OBC)',
  },
  {
    name: 'EWS',
  },
  {
    name: 'Other',
  },
]

export const religionList = [
  {
    name: 'Hinduism',
  },
  {
    name: 'African Traditional & Diasporic',
  },
  {
    name: 'Agnostic',
  },
  {
    name: 'Atheist',
  },
  {
    name: 'Baha‘i',
  },
  {
    name: 'Buddhism',
  },
  {
    name: 'Cao Dai',
  },
  {
    name: 'Chinese Traditional Religion',
  },
  {
    name: 'christianity',
  },
  {
    name: 'Islam',
  },
  {
    name: 'Jainism',
  },
  {
    name: 'Juche',
  },
  {
    name: 'Judaism',
  },
  {
    name: 'Neo-Paganism',
  },
  {
    name: 'Non-religious',
  },
  {
    name: 'Rastafarianism',
  },
  {
    name: 'Secular',
  },
  {
    name: 'Shinto',
  },
  {
    name: 'Sikhism',
  },
  {
    name: 'Spiritism',
  },
  {
    name: 'Tenrikyo',
  },
  {
    name: 'Unitarian-Universalism',
  },
  {
    name: 'Zoroastrianism',
  },
  {
    name: 'Primal-indigenous',
  },
  {
    name: 'Other',
  },
]

export const locationList = [
  {
    name: 'Bengalore',
  },
  {
    name: 'Chennai',
  },
  {
    name: 'Mumbai',
  },
  {
    name: 'Hyderabad',
  },
  {
    name: 'New Delhi',
  },
]
export const genderOptions = [
  {
    value: 'MALE',
    name: 'Male',
  },
  {
    value: 'FEMALE',
    name: 'Female',
  },
  {
    value: 'TRANSGENDER',
    name: 'Transgender',
  },
  {
    value: 'INTERSEX',
    name: 'Intersex',
  },
  {
    value: 'NON_BINARY',
    name: 'Non Binary',
  },
  {
    value: 'PREFER_NOT_TO_SAY',
    name: 'Prefer not to say',
  },
  {
    value: 'OTHER',
    name: 'Other',
  },
]
export const CountryCode = [
  {
    id: '1',
    value: '+91',
  },
]

export const countryData = [
  {
    id: '1',
    value: 'India',
  },
]

export const stateData = [
  {
    id: '1',
    value: 'Tamilnadu',
  },
]

export const cityData = [
  {
    id: '1',
    value: 'chennai',
  },
]

export const ComeAcross = [
  {
    id: '1',
    value: 'PluginLive',
  },
  {
    id: '2',
    value: 'LinkedIn',
  },
  {
    id: '3',
    value: 'Social media',
  },
  {
    id: '4',
    value: 'Referral from a friend or colleague',
  },
  {
    id: '5',
    value: 'Others',
  },
]

export const LoveAboutagsData = [
  'Good Experience',
  'Helpful Features',
  'Smooth Navigation',
  'Effective Search',
  'User-Friendly',
  'Responsive Site',
  'Positive Process',
  'Almost Perfect',
  'Great Platform',
]
export const ExperiencetagsData = [
  'Technical Glitches',
  'Navigation Confusion',
  'Slow Loading',
  'Login Problems',
  'Error Messages',
]
